import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import sanitizeHtml from 'sanitize-html';
import throttle from 'lodash.throttle';
import { Form, Input, Select } from 'antd';
import { EditorElementPopover } from '../EditorElementPopover';

const { Option } = Select;
const FormItem = Form.Item;

export class PInput extends React.Component {
  state = {
    showBtn: false,
    nameValidateStatus: 'success',
    nameHelp: '',
    placeholderValidateStatus: 'success',
    placeholderHelp: '',
  };

  static propTypes = {
    // name that shows up on the lead
    name: PropTypes.string,
    // text | password | textarea | submit | email | url | tel
    type: PropTypes.string,

    // placeholder text
    placeholder: PropTypes.string,

    color: PropTypes.string,

    className: PropTypes.string,

    address: PropTypes.array,
    updateNode: PropTypes.func,

    publish: PropTypes.bool,
  };

  static defaultProps = {
    name: 'name',
    type: 'text',
    placeholder: 'placeholder',

    publish: false,
  };

  onPopoverMouseOver = (e) => {
    e.stopPropagation();
  };

  onPopoverMouseOut = (e) => {
    e.stopPropagation();
  };

  typeChanged = (v) => {
    this.props.updateNode(this.props.address, { type: v });
  };

  onNameChange = throttle((value) => {
    const sanitized = sanitizeHtml(value.trim(), {
      allowedTags: [],
      allowedAttributes: {},
    });
    if (sanitized.length === 0) {
      this.setState({
        nameValidateStatus: 'warning',
        nameHelp: 'Cannot be empty',
      });
    }
    else if (sanitized.length > 16) {
      this.setState({
        nameValidateStatus: 'warning',
        nameHelp: 'Too long',
      });
    }
    else {
      this.setState({
        nameValidateStatus: 'success',
        nameHelp: null,
      });
      this.props.updateNode(this.props.address, { name: sanitized });
    }
  }, 300);

  onPlaceholderChange = throttle((value) => {
    const sanitized = sanitizeHtml(value.trim(), {
      allowedTags: [],
      allowedAttributes: {},
    });
    if (sanitized.length > 32) {
      this.setState({
        placeholderValidateStatus: 'warning',
        placeholderHelp: 'too long',
      });
    }
    else {
      this.setState({
        placeholderValidateStatus: 'success',
        placeholderHelp: null,
      });
      this.props.updateNode(this.props.address, { placeholder: sanitized });
    }
  }, 300);

  popoverContent = () => {
    const { type, name, placeholder } = this.props;
    return (
      <React.Fragment>

        <div className="label">
          <div className="main">Field type</div>
          <div className="help">The format you want data to be entered in.</div>
        </div>

        <Select
          defaultValue={type} onChange={this.typeChanged}
          style={{
            width: '100%',
          }}
        >
          <Option value="text">Text</Option>
          <Option value="email">Email</Option>
          <Option value="url">URL</Option>
          <Option value="tel">Phone number</Option>
          <Option value="textarea">Multi-line text</Option>
        </Select>

        <div className="divider" />

        <div className="label">
          <div className="main">Placeholder</div>
          <div className="help">Text displayed in empty fields</div>
        </div>

        <FormItem validateStatus={this.state.placeholderValidateStatus} hasFeedback={false} help={this.state.placeholderHelp} >
          <Input onChange={(e) => { this.onPlaceholderChange(e.target.value); }} defaultValue={placeholder} />
        </FormItem>

        <div className="divider" />

        <div className="label">
          <div className="main">Name</div>
          <div className="help">Used only for reporting. Hidden from visitors.</div>
        </div>

        <FormItem validateStatus={this.state.nameValidateStatus} hasFeedback={false} help={this.state.nameHelp} >
          <Input onChange={(e) => { this.onNameChange(e.target.value); }} defaultValue={name} />
        </FormItem>

      </React.Fragment>
    );
  };

  onMouseOver = (e) => {
    this.setState({ showBtn: true });
    e.stopPropagation();
  };

  onMouseOut = (e) => {
    this.setState({ showBtn: false });
    e.stopPropagation();
  };

  render() {
    const {
      type,
      placeholder,
      name,
      publish,
    } = this.props;

    const nodeProps = {
      className: cx(
        this.props.className,
      ),
      type,
      name,
      placeholder,
    };

    return (
      <div
        className={cx(
          'pinput',
        )}
        onMouseOver={this.onMouseOver}
        onFocus={this.onMouseOver}
        onMouseOut={this.onMouseOut}
        onBlur={this.onMouseOut}
      >
        { (type === 'textarea') ? (
          <textarea {...nodeProps} rows="3" />
        ) : (
          <input {...nodeProps} />
        )}

        <EditorElementPopover
          usecase="input"
          showBtn={this.state.showBtn}
          title="Field settings"
          content={this.popoverContent()}
          placement="bottomLeft"
          btnLabel="field"
          publish={publish}
        />

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/editor/elements/PInput.jsx